import { OnInit, OnDestroy } from '@angular/core';
import { ShoppingService } from "../../shared/services/shopping.service";
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'app/shared/services/alert.service';
import { AuthService } from '../../login/services/auth.service';
import { Role } from '../../shared/models/role';
import { BillingService } from 'app/shared/services/billing.service';
var CheckoutComponent = /** @class */ (function () {
    function CheckoutComponent(shopping, router, alertService, route, billingService, authService) {
        var _this = this;
        this.shopping = shopping;
        this.router = router;
        this.alertService = alertService;
        this.route = route;
        this.billingService = billingService;
        this.authService = authService;
        this._inCheckoutProcess = false;
        this.useSavedCard = false;
        this._loadingPaymentInformation = false;
        this._isAdmin = false;
        this._userSubscription = this.authService.getLoginState().subscribe(function (loginState) {
            if (loginState.user) {
                _this._isAdmin = loginState.user.role <= Role.Admin;
            }
            else {
                _this._isAdmin = false;
            }
        });
    }
    CheckoutComponent.prototype.ngOnDestroy = function () {
        this._userSubscription.unsubscribe();
    };
    CheckoutComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._loadingPaymentInformation = true;
        this.billingService.getBillingDetails().then(function (details) {
            _this._loadingPaymentInformation = false;
            _this._billingDetails = details; // use the first one.
            if (_this._billingDetails.hasCards()) {
                _this._billingCard = _this._billingDetails.cards[0];
                _this.setCheckoutSavedCard();
            }
        })
            .catch(function (error) {
            console.error(error);
            _this._loadingPaymentInformation = false;
            _this.alertService.error("There was an error loading your payment information from the server.  Use a new card or contact support");
        });
    };
    Object.defineProperty(CheckoutComponent.prototype, "isSingleOrder", {
        get: function () {
            return this.shopping.isSingleCheckoutOrder();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutComponent.prototype, "loadingPaymentInformation", {
        get: function () {
            return this._loadingPaymentInformation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutComponent.prototype, "inCheckoutProcess", {
        get: function () {
            return this._inCheckoutProcess;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutComponent.prototype, "hasItems", {
        get: function () {
            return this.shopping.hasItems;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutComponent.prototype, "orderTotal", {
        get: function () {
            return this.shopping.cartTotal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutComponent.prototype, "items", {
        get: function () {
            return this.shopping.cartItems;
        },
        enumerable: true,
        configurable: true
    });
    CheckoutComponent.prototype.removeItem = function (item) {
        var _this = this;
        this.shopping.removeItemFromCart(item).then(function () {
            var message = item.name + " removed from your cart.";
            _this.alertService.success(message);
        });
    };
    CheckoutComponent.prototype.shouldShowPaymentInformation = function () {
        // we only show if this is a paid item, and if we have a saved billing card.
        if (this.shopping.cartTotal > 0) {
            // if we are an admin and haven't setup a billing profile we want to show the payment details.
            if (this.canUpdateBillingProfile()) {
                return true;
            }
            if (this._billingDetails.hasCards() != null) {
                return true;
            }
        }
        return false;
    };
    CheckoutComponent.prototype.setCheckoutSavedCard = function () {
        this.useSavedCard = true;
    };
    CheckoutComponent.prototype.setCheckoutNewCard = function () {
        this.useSavedCard = false;
    };
    Object.defineProperty(CheckoutComponent.prototype, "BillingCard", {
        get: function () {
            return this._billingCard;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutComponent.prototype, "useSavedCard", {
        get: function () {
            return this._useExistingCard;
        },
        set: function (v) {
            this._useExistingCard = v;
        },
        enumerable: true,
        configurable: true
    });
    CheckoutComponent.prototype.canUpdateBillingProfile = function () {
        return this._isAdmin;
    };
    CheckoutComponent.prototype.openCheckout = function () {
        var _this = this;
        this._inCheckoutProcess = true;
        this.shopping.checkout(this.useSavedCard).then(function () {
            _this.router.navigate(["/admin", "shop", "checkout", "thankyou"]);
        })
            .catch(function (error) {
            console.error(error);
            _this.alertService.error("An error occurred in processing your checkout.  Check your card information and try again or contact customer support.");
            _this._inCheckoutProcess = false;
        });
    };
    CheckoutComponent.prototype.cancelSingleCheckoutOrder = function () {
        var returnUrl = this.shopping.getSingleItemCheckoutReturnUrl();
        this.shopping.endSingleItemCheckout();
        if (!returnUrl) {
            console.error("No return url found to return to for single item checkout");
            returnUrl = "/admin/clients/";
        }
        this.router.navigateByUrl(returnUrl);
    };
    return CheckoutComponent;
}());
export { CheckoutComponent };



// WEBPACK FOOTER //
// ./src/app/admin/checkout/checkout.component.ts.pre-build-optimizer.js